import React, { CSSProperties, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { IOrgStageCoordsGetterOutput } from '../../functions/getOrgStages-1'
import { colors, constants } from '../../../../Constants'
import RootStoreContext from '../../../../storage/RootStore'
import './Views.scss'
import { getDocInfo, getDocsForStage } from '../../../../dict/DOCS'

/// functions
/// types
/// components

interface DocumentsProps extends IOrgStageCoordsGetterOutput { }

export const Documents: React.FC<DocumentsProps> = observer(({
    orgStagesCoords, arrayOrgNodes, connectionDotsCoords, arrayStages
}) => {

    const { selection, dimensions } = useContext(RootStoreContext)
    const { BLOCK } = constants

    return (<>
        {arrayStages && arrayStages.filter((stageID, i) => i > 0).map((stageID, stageIndex) => {

            const x = BLOCK.WIDTH * (stageIndex + 1);
            const y = 0;

            return (<g x={x} y={y}>

                <foreignObject x={x} y={y} width={BLOCK.WIDTH} height={dimensions.HEIGHT_MATRIX_CONTAINER}>
                    <div style={{ width: BLOCK.WIDTH, height: dimensions.HEIGHT_MATRIX_CONTAINER }} >

                        {getDocsForStage(stageID).map(documentID => {

                            const { name } = getDocInfo(documentID)

                            const isSelected = documentID === selection.doc || (stageID === selection.stage && !selection.doc);
                            const styleSelected: CSSProperties = {
                                background: constants.BLOCK.COLOR_SELECTED,
                            }

                            const onClick = (e) => {
                                selection.setStage(stageID)
                                selection.setDoc(documentID)
                                e.preventDefault()
                                e.stopPropagation()
                            }

                            return (
                                <div key={documentID}  className={'svg-div'} style={{textAlign: 'left', ...(isSelected ? styleSelected : {}) }} onClick={onClick}>
                                    {name}
                                </div>
                            )
                        })}
                    </div>
                </foreignObject>

            </g>)
        })}
    </>)
})
